import {clone} from 'remeda';

import {OrderReviewTotalsSegmentsType} from 'desktop/types/orderReviewTotalsType';

import {getCurrentBenefitsBrand} from './getCurrentBenefitsBrand';

const BASE_ROW = {
    area: null,
    noSpecialPrice: 0,
    noSpecialPriceWithTax: 0,
    price: 0,
    value: 0,
};

export const TAX_ROW: OrderReviewTotalsSegmentsType = {
    ...BASE_ROW,
    code: 'tax',
    title: 'Sales tax',
};

// ts-unused-exports:disable-next-line
export const CO_PAY: OrderReviewTotalsSegmentsType = {
    ...BASE_ROW,
    code: 'copay',
    title: 'Member Co-pay',
};

export const DUE_NOW: OrderReviewTotalsSegmentsType = {
    ...BASE_ROW,
    code: 'due_now',
    title: 'Due Now',
};

export const GRAND_TOTAL_TITLE = 'Grand Total';
export const SUBTOTAL_TITLE = 'Subtotal';
export const SALES_TAX_TITLE = 'Sales tax';

/**
 * Get total rows with discount totals
 * @param {OrderReviewTotalsSegmentsType[]} firstTotalList - order review totals
 * @param {string} copay - copay of order review totals
 * @return {OrderReviewTotalsSegmentsType[]} - Actual totals
 */
export const addDiscountTotals = (
    firstTotalList: OrderReviewTotalsSegmentsType[],
    copay: number,
): OrderReviewTotalsSegmentsType[] => {
    const totals = clone(firstTotalList);

    const discountIndex = totals.findIndex(total =>
        ['discount', 'benefits', 'uhc_benefits'].includes(total.code),
    );
    if (discountIndex === -1) return totals;
    totals.splice(discountIndex + 1, 0, {...CO_PAY, price: copay});
    totals[discountIndex].title = `${getCurrentBenefitsBrand().brandName} Plan Benefits`;

    return totals;
};
